import {ROUTES} from '../config';
export function getDefaultRoute(){
    const defaultRoute=ROUTES.find(route=>route.default);
    return defaultRoute?defaultRoute:ROUTES[0];
}